const ConnectWithStripeButtonSvg = ({ backgroundFill, textFill }: { backgroundFill?: string; textFill?: string }) => {
  return (
    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 180 38'>
      <path
        className='st0'
        fill={backgroundFill || '#635BFF'}
        d='M4,0h172c2.2,0,4,1.8,4,4v30c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M26.4,18.6c0-2.3,1.3-3.9,3-3.9c1.3,0,2.2,0.8,2.5,2l1.8-0.6c-0.6-1.9-2.1-3.1-4.3-3.1c-2.9,0-5,2.3-5,5.6
	s2.1,5.6,5,5.6c2.2,0,3.7-1.2,4.3-3.1l-1.8-0.6c-0.3,1.3-1.2,2-2.5,2C27.6,22.5,26.4,20.9,26.4,18.6z M42,20.1
	c0-2.4-1.6-4.1-3.8-4.1s-3.8,1.6-3.8,4.1s1.6,4.1,3.8,4.1C40.5,24.2,42,22.5,42,20.1z M36.3,20.1c0-1.6,0.8-2.6,2-2.6s2,1,2,2.6
	s-0.8,2.6-2,2.6S36.3,21.7,36.3,20.1z M43.4,24h1.8v-4.6c0-1.1,0.8-1.7,1.6-1.7c1,0,1.4,0.7,1.4,1.7V24H50v-5.2c0-1.7-1-2.8-2.6-2.8
	c-1,0-1.7,0.5-2.2,1v-0.8h-1.8V24z M51.9,24h1.8v-4.6c0-1.1,0.8-1.7,1.6-1.7c1,0,1.4,0.7,1.4,1.7V24h1.8v-5.2c0-1.7-1-2.8-2.6-2.8
	c-1,0-1.7,0.5-2.2,1v-0.8h-1.8V24z M63.7,24.2c1.6,0,2.8-0.8,3.4-2.2l-1.5-0.6c-0.2,0.8-0.9,1.3-1.8,1.3c-1.2,0-2-0.8-2.1-2.2h5.5
	v-0.6c0-2.2-1.2-3.9-3.5-3.9c-2.2,0-3.8,1.8-3.8,4.1C59.9,22.5,61.4,24.2,63.7,24.2z M63.6,17.5c1.1,0,1.7,0.8,1.7,1.6h-3.6
	C61.9,18,62.7,17.5,63.6,17.5z M69.8,20.1c0-1.6,0.8-2.5,2.1-2.5c1,0,1.5,0.6,1.8,1.5l1.5-0.8c-0.4-1.3-1.6-2.2-3.3-2.2
	c-2.2,0-3.9,1.7-3.9,4.1s1.6,4.1,3.9,4.1c1.7,0,2.9-1,3.3-2.3l-1.5-0.8c-0.2,0.9-0.8,1.5-1.8,1.5C70.6,22.6,69.8,21.7,69.8,20.1z
	 M76.4,22c0,1.6,0.8,2.1,2.3,2.1c0.5,0,0.9,0,1.2-0.1v-1.5c-0.3,0-0.4,0-0.7,0c-0.6,0-1.1-0.1-1.1-0.8v-4.1h1.7v-1.5h-1.7v-2.3h-1.8
	v2.3h-1.1v1.5h1.1L76.4,22L76.4,22z M88.1,16.1l-1.4,5.2l-1.4-5.2h-1.8l2.4,7.9h1.6l1.4-5.2l1.4,5.2h1.6l2.4-7.9h-1.8L91,21.3
	l-1.4-5.2C89.6,16.1,88.1,16.1,88.1,16.1z M95.2,15.1H97v-1.8h-1.9L95.2,15.1L95.2,15.1z M97,16.1h-1.8V24H97V16.1z M99,22
	c0,1.6,0.8,2.1,2.3,2.1c0.5,0,0.9,0,1.2-0.1v-1.5c-0.3,0-0.4,0-0.7,0c-0.6,0-1.1-0.1-1.1-0.8v-4.1h1.7v-1.5h-1.7v-2.3H99v2.3h-1.1
	v1.5H99V22z M103.9,24h1.8v-4.6c0-1.1,0.8-1.7,1.6-1.7c1,0,1.4,0.7,1.4,1.7V24h1.8v-5.2c0-1.7-1-2.8-2.6-2.8c-1,0-1.7,0.5-2.2,1
	v-3.7h-1.8C103.9,13.3,103.9,24,103.9,24z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M141.5,26.4v-3c0.4,0.3,0.9,0.7,1.9,0.7c1.9,0,3.6-1.5,3.6-4.9c0-3.1-1.7-4.8-3.6-4.8c-1,0-1.7,0.5-2.1,0.9
	l-0.1-0.6h-2.3V27L141.5,26.4z M142.7,16.7c1,0,1.6,1.1,1.6,2.5c0,1.5-0.6,2.5-1.6,2.5c-0.6,0-1-0.2-1.3-0.5v-4
	C141.8,17,142.1,16.7,142.7,16.7z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M152.1,24.2c1.3,0,2.2-0.3,3-0.7v-2.2c-0.7,0.4-1.5,0.6-2.6,0.6s-1.9-0.4-2.1-1.7h5.2c0-0.2,0-0.7,0-1
	c0-2.8-1.3-4.9-3.8-4.9s-4.1,2.2-4.1,4.9C147.7,22.5,149.5,24.2,152.1,24.2z M151.8,16.5c0.6,0,1.3,0.5,1.3,1.7h-2.8
	C150.4,17.1,151.1,16.5,151.8,16.5z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M132,17.5c0.6-0.9,1.7-0.7,2-0.6v-2.5c-0.4-0.1-1.6-0.4-2.1,0.8l-0.2-0.8h-2.3v9.4h2.6V17.5z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M120,21.2c0,0.5-0.4,0.6-1,0.6c-0.9,0-2-0.4-2.9-0.9v2.6c1,0.4,2,0.6,2.9,0.6c2.2,0,3.7-1.1,3.7-3
	c0-3.2-4-2.6-4-3.8c0-0.4,0.3-0.6,0.9-0.6c0.8,0,1.8,0.2,2.6,0.7v-2.6c-0.9-0.4-1.7-0.5-2.6-0.5c-2.1,0-3.6,1.1-3.6,3
	C116,20.4,120,19.9,120,21.2z'
      />
      <path
        className='st1'
        fill={textFill || '#FFFFFF'}
        d='M126.4,24.2c0.8,0,1.5-0.2,1.9-0.4v-2.2c-0.3,0.1-2,0.6-2-1v-3.8h2v-2.3h-2v-2.3l-2.6,0.6v8.6
	C123.7,23,124.8,24.2,126.4,24.2z'
      />
      <path className='st1' fill={textFill || '#FFFFFF'} d='M134.9,11.6v2.1l2.7-0.5V11L134.9,11.6z' />
      <path className='st1' fill={textFill || '#FFFFFF'} d='M137.5,14.5h-2.6v9.3h2.6V14.5z' />
    </svg>
  );
};

export default ConnectWithStripeButtonSvg;
